import { useEffect } from 'react';

export const useMetaTag = (name: string): [() => string, (value: string) => void] => {
    const getValue = () => {
        const metaTag = document.querySelector(`meta[name="${name}"]`);
        return metaTag?.getAttribute('content') || '';
    };

    const setValue = (value: string) => {
        const metaTag = document.querySelector(`meta[name="${name}"]`);
        if (metaTag) {
            metaTag.setAttribute('content', value);
        } else {
            const newMetaTag = document.createElement('meta');
            newMetaTag.name = name;
            newMetaTag.content = value;
            document.head.appendChild(newMetaTag);
        }
    };

    return [getValue, setValue];
};

export const useDocumentTitle = (title: string) => {
    useEffect(() => {
        document.title = title;
    }, [title]);
};
